import { useState } from 'react';
import { CanonicalContact, ContactRole } from '../helpers/contactShape';

export interface ContactPickerUIState {
  searchTerm: string;
  selectedRoles: ContactRole[];
  selectedCategories: string[];
  selectedContact: CanonicalContact | null;
  onChangeSearchTerm: (term: string) => void;
  onChangeSelectedRoles: (roles: ContactRole[]) => void;
  onChangeSelectedCategories: (categories: string[]) => void;
  onSelectContact: (contact: CanonicalContact) => void;
  onClearSelectedContact: () => void;
}

export const useContactPickerUIState = (): ContactPickerUIState => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedRoles, setSelectedRoles] = useState<ContactRole[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedContact, setSelectedContact] = useState<CanonicalContact | null>(
    null
  );

  const onChangeSearchTerm = (term: string): void => {
    setSearchTerm(term);
  };

  const onChangeSelectedRoles = (roles: ContactRole[]): void => {
    setSelectedRoles(roles);
  };

  const onChangeSelectedCategories = (categories: string[]): void => {
    setSelectedCategories(categories);
  };

  const onSelectContact = (contact: CanonicalContact): void => {
    setSelectedContact(contact);
  };

  const onClearSelectedContact = (): void => {
    setSelectedContact(null);
  };

  return {
    searchTerm,
    selectedRoles,
    selectedCategories,
    selectedContact,
    onChangeSearchTerm,
    onChangeSelectedRoles,
    onChangeSelectedCategories,
    onSelectContact,
    onClearSelectedContact,
  };
};
